import { defineComponent } from 'vue';
import CategoryFourFileUploadComponent from '@/components/CategoryFour/CategoryFourFileUploadComponent.vue';
export default defineComponent({
    name: 'CategoryFourFileUploadDialog',
    props: {
        propSelected: Array
    },
    components: { CategoryFourFileUploadComponent },
    data: function () {
        return {
            show: false
        };
    },
    methods: {
        refresh() {
            this.$emit('refresh');
        },
        showHideDialog() {
            this.show = !this.show;
        },
        createNew() {
            this.show = true;
        }
    }
});
